export const CLOSE_ALERT = 'CLOSE_ALERT';

export const closeAlert = () => (dispatch, getState) => {
    dispatch(_closeAlert());
}


const _closeAlert = ( ) => ({
    type: CLOSE_ALERT,
    payload: {}
})
